import { extendTheme } from '@chakra-ui/react'
import { colors } from './colors'

const defaultTheme = extendTheme({
  colors,
})

export { defaultTheme }
